import React from "react";

export default function UsuariosFilters({
  search,
  setSearch,
  roleFilter,
  setRoleFilter,
  statusFilter,
  setStatusFilter,
  centerFilter,
  setCenterFilter,
  roles,
  centros,
  limpiarFiltros,
}) {
  const hasActiveFilters =
    search.trim() !== "" ||
    roleFilter !== "todos" ||
    statusFilter !== "todos" ||
    centerFilter !== "todos";

  return (
    <div className="management-card usuarios-filters-card management-filters-card mb-4">
      <div className="row g-3 usuarios-filters-grid align-items-end">
        <div className="col-12 col-md-3">
          <label className="form-label dashboard-label">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Nombre, documento o correo..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label dashboard-label">Rol</label>
          <select
            className="form-select"
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="todos">Todos</option>
            {roles.map((rol) => (
              <option key={rol.id} value={String(rol.id)}>
                {rol.nombre}
              </option>
            ))}
            <option value="sin-rol">Sin rol</option>
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label dashboard-label">Estado</label>
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="todos">Todos</option>
            <option value="activos">Activos</option>
            <option value="inactivos">Inactivos</option>
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label dashboard-label">Centro</label>
          <div className="input-group">
            <select
              className="form-select"
              value={centerFilter}
              onChange={(e) => setCenterFilter(e.target.value)}
            >
              <option value="todos">Todos</option>
              {centros.map((centro) => (
                <option key={centro.id} value={String(centro.id)}>
                  {centro.alias || centro.nombre}
                </option>
              ))}
              <option value="sin-centro">Sin centro</option>
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros} disabled={!hasActiveFilters}>
              <i className="bi bi-eraser me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


